import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import styles from "./FrameWrapperRubric.module.scss";
import IconClose from "../../common/icons/IconClose";

const RubricLoadingSkeleton = ({ closePopup, containerRef }) => {
  return (
    <>
      <div className={styles.modalBackdrop} onClick={closePopup} />
      <div className={styles.modalWrapper}>
        <div className={styles.contentContainer} ref={containerRef}>
          {/* Header Skeleton */}
          <div className={styles.headerSkeleton}>
            <div className={styles.headerTop}>
              <div className={styles.typeSection}>
                <Skeleton width={80} height={20} />
              </div>
              <div className={styles.chainSection}>
                <Skeleton circle height={40} width={40} />
              </div>
            </div>
            <div className={styles.titleSection}>
              <Skeleton height={32} count={2} />
            </div>
          </div>

          {/* Questions Skeleton */}
          <div className={styles.questionsSkeleton}>
            {[...Array(5)].map((_, index) => (
              <div key={index} className={styles.questionSkeleton}>
                <div className={styles.questionHeader}>
                  <Skeleton height={24} />
                  <div className={styles.questionMeta}>
                    <Skeleton width={120} height={16} />
                    <Skeleton width={80} height={16} />
                  </div>
                </div>
                <div className={styles.questionContent}>
                  <Skeleton height={20} count={3} />
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className={styles.closeIcon} onClick={closePopup}>
          <IconClose />
        </div>
      </div>
    </>
  );
};

export default RubricLoadingSkeleton; 